import { CommonModule, DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

const THEME_KEY = 'ACM_Theme' as const;
const lightSide = 'light-side' as const;

@Component({
  selector: 'angular-community-theme-toggler',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatButtonModule],
  template: `
    <button mat-button (click)="toggleTheme()">
      <mat-icon>{{ themeIcon }}</mat-icon>
    </button>
  `,
  styleUrls: ['./theme-toggler.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeTogglerComponent implements OnInit {
  #lightTheme = false;

  get themeIcon(): string {
    return this.#lightTheme ? 'dark_mode_outline' : 'brightness_7_outline';
  }

  constructor(@Inject(DOCUMENT) private readonly _document: Document) {}

  ngOnInit(): void {
    this.#lightTheme = localStorage.getItem(THEME_KEY) === lightSide;

    this.#setLightTheme();
  }

  toggleTheme(): void {
    this.#lightTheme = !this.#lightTheme;

    this.#setLightTheme();

    if (this.#lightTheme) {
      localStorage.setItem(THEME_KEY, lightSide);
    } else {
      localStorage.removeItem(THEME_KEY);
    }
  }

  #setLightTheme(): void {
    this._document.body.classList.toggle('light-side-theme', this.#lightTheme);
    this._document.body.classList.toggle('dark-side-theme', !this.#lightTheme);
  }
}
